import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Alert,
  IconButton
} from '@mui/material';
import { Block, Close, Warning } from '@mui/icons-material';

const BlockedUserDialog = ({ 
  open, 
  onClose, 
  userAddress, 
  action = 'perform this action',
  title = 'Access Restricted'
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Block color="error" />
          {title}
          <IconButton 
            onClick={onClose}
            sx={{ ml: 'auto' }}
            size="small"
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            User Account Blocked
          </Typography>
        </Alert>
        
        <Typography variant="body1" paragraph>
          The wallet address <strong>{userAddress}</strong> has been blocked by administrators and cannot {action}.
        </Typography>
        
        <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="body2" color="textSecondary">
            <Warning sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
            If you believe this is an error, please contact support with your wallet address for assistance.
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockedUserDialog;
